import API from 'services/API';
import useAppMutation from 'hooks/useAppMutation';
import { useQueryClient } from '@tanstack/react-query';
import { PROMO_CODES_BASE_QUERY_KEY } from './useFetchPromoCodes';

export const useDeletePromoCode = () => {
  const queryClient = useQueryClient();

  return useAppMutation(
    (id: string) => API.delete(`/api/v3.2/promo-codes/${id}`),
    {
      onSuccess: () =>
        queryClient.invalidateQueries([PROMO_CODES_BASE_QUERY_KEY]),
    },
  );
};
